import AoneService from ".././axiosbase";
export const getChuteConfigs = async (params) => {
  try {
    return await AoneService.get(
      "sorting-panel-v2/v1/api/sorting-configs" + params
    );
  } catch (error) {
    return error;
  }
};

export const postChuteConfigs = async (data) => {
  try {
    return await AoneService.post("sorting-panel-v2/v1/api/sorting-configs", data);
  } catch (error) {
    return error;
  }
};

export const putChuteConfigs = async (params, data) => {
  try {
    return await AoneService.put(
      `sorting-panel-v2/v1/api/sorting-configs/${params}`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const deleteChuteConfigs = async (params) => {
  try {
    return await AoneService.delete(
      "sorting-panel-v2/v1/api/sorting-configs/" + params
    );
  } catch (error) {
    return error;
  }
};

export const getChuteByIdTemplate = async () => {
  try {
    return await AoneService.get(
      "sorting-panel-v2/v1/api/sorting-configs/mapping/template",
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const postChuteByIdTemplate = async (params, data) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/sorting-configs/${params}/mapping/template`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

export const downloadChuteById = async (params) => {
  try {
    return await AoneService.get(
      `sorting-panel-v2/v1/api/sorting-configs/${params}/mapping/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

export const getChuteConfigsById = async (params1, params2) => {
  try {
    return await AoneService.get(
      `sorting-panel-v2/v1/api/sorting-configs/${params1}/mapping/` + params2
    );
  } catch (error) {
    return error;
  }
};

export const postChuteConfigsById = async (params, data) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/sorting-configs/${params}/mapping/`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const putChuteConfigsById = async (params, data) => {
  try {
    return await AoneService.put(
      `sorting-panel-v2/v1/api/sorting-configs/${params}/mapping/`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const deleteChuteConfigsById = async (params1, params2) => {
  try {
    return await AoneService.delete(
      `sorting-panel-v2/v1/api/sorting-configs/${params1}/mapping?` + params2
    );
  } catch (error) {
    return error;
  }
};
export const deleteChuteConfigsByIdV2 = async (params) => {
  try {
    return await AoneService.delete(
      `sorting-panel-v2/v1/api/sorting-configs/mapping/${params}`
    );
  } catch (error) {
    return error;
  }
};
export const deleteChuteConfigsBulkById = async (params1, data) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/sorting-configs/${params1}/mappings`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const getAgentConfigs = async (params) => {
  try {
    return await AoneService.get("sorting-panel-v2/v1/api/agents" + params);
  } catch (error) {
    return error;
  }
};

//get by machine scans
export const getMachineScans = async (params) => {
  try {
    return await AoneService.get(
      "sorting-panel-v2/v1/api/scans/chute-request" + params
    );
  } catch (error) {
    return error;
  }
};
//get by sorting configs
export const getSortingConfig = async (params) => {
  try {
    return await AoneService.get(
      "sorting-panel-v2/v1/api/sorting-configs" + params
    );
  } catch (error) {
    return error;
  }
};
//export machine scans
export const exportMachineScans = async (params) => {
  try {
    return await AoneService.get(
      "sorting-panel-v2/v1/api/scans/export?" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
//receive-machinescans
export const receiveMachineScan = async (id) => {
  try {
    return await AoneService.post(`sorting-panel-v2/v1/api/events/receive`, id);
  } catch (error) {
    return error;
  }
};
//outscan-machinescans
export const outScanMachineScan = async (id) => {
  try {
    return await AoneService.post(`sorting-panel-v2/v1/api/events/out-scan`, id);
  } catch (error) {
    return error;
  }
};
export const postAgentConfigs = async (data) => {
  try {
    return await AoneService.post("sorting-panel-v2/v1/api/agents", data);
  } catch (error) {
    return error;
  }
};

export const putAgentConfigs = async (params, data) => {
  try {
    return await AoneService.put(`sorting-panel-v2/v1/api/agents/${params}`, data);
  } catch (error) {
    return error;
  }
};

export const deleteAgentConfigs = async (params) => {
  try {
    return await AoneService.delete("sorting-panel-v2/v1/api/agents/" + params);
  } catch (error) {
    return error;
  }
};

export const deactivateAgentConfigs = async (params, data) => {
  try {
    return await AoneService.patch(
      `sorting-panel-v2/v1/api/agents/${params}/status`,
      data
    );
  } catch (error) {
    return error;
  }
};

export const downloadAgents = async () => {
  try {
    return await AoneService.get("sorting-panel-v2/v1/api/agents/download", {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//shipment type lookup
export const getShipmentTypes = async () => {
    try {
        return await AoneService.get(`ops/api/v1/lookups/PackageType`);
    } catch (error) {
        return error;
    }
}

// getbags
export const getBags = async (params) => {
  try {
    return await AoneService.get("sorting-panel-v2/v1/api/bags" + params);
  } catch (error) {
    return error;
  }
};

//outscan bulk bag
export const outScanBulkBag = async (data) => {
  try {
    return await AoneService.post("sorting-panel-v2/v1/api/bags/out-scan", data);
  } catch (error) {
    return error;
  }
};

//export bulk bag
export const exportBulkBag = async (data) => {
  try {
    return await AoneService.post("sorting-panel-v2/v1/api/bags/export", data, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//outscan download
export const outScanBag = async (params) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/bags/${params}/out-scan`
    );
  } catch (error) {
    return error;
  }
};

//inscan download
export const inScanBag = async (params) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/bags/${params}/in-scan`
    );
  } catch (error) {
    return error;
  }
};

//move consignments
export const moveConsignment = async (params, data) => {
  try {
    return await AoneService.put(
      `sorting-panel-v2/v1/api/bags/${params}/consignment`,
      data
    );
  } catch (error) {
    return error;
  }
};

//label download
export const labelBag = async (params) => {
  try {
    return await AoneService.get(`sorting-panel-v2/v1/api/bags/${params}/label`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//consignment download
export const consignmentBag = async (params) => {
  try {
    return await AoneService.get(
      `sorting-panel-v2/v1/api/bags/${params}/consignment/export`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//template download for consignment upload
export const templateConsigment = async () => {
  try {
    return await AoneService.get(
      `sorting-panel-v2/v1/api/bags/consignment/template`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//create bags
export const postBags = async (data) => {
  try {
    return await AoneService.post("sorting-panel-v2/v1/api/bags/bag", data);
  } catch (error) {
    return error;
  }
};

//create consignment
export const postWaybill = async (orderId, data) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/bags/${orderId}/order`,
      data
    );
  } catch (error) {
    return error;
  }
};

//edit bags
export const editBags = async (params, data) => {
  try {
    return await AoneService.put(`sorting-panel-v2/v1/api/bags/${params}`, data);
  } catch (error) {
    return error;
  }
};

//edit waybills under bags
export const editWaybillsbyBagId = async (bagId, orderId, params) => {
  try {
    return await AoneService.put(
      `sorting-panel-v2/v1/api/bags/${bagId}/order/${orderId}`,
      params
    );
  } catch (error) {
    return error;
  }
};

//get bags by id
export const getBagsById = async (params1, params2) => {
  try {
    return await AoneService.get(
      `sorting-panel-v2/v1/api/bags/${params1}/consignment` + params2
    );
  } catch (error) {
    return error;
  }
};

//import waybills
export const postWaybillByTemplate = async (params, data) => {
  try {
    return await AoneService.post(
      `sorting-panel-v2/v1/api/bags/${params}/consignment/upload`,
      data,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  } catch (error) {
    return error;
  }
};

//delete bags
export const deleteBagById = async (params) => {
  try {
    return await AoneService.delete("sorting-panel-v2/v1/api/bags/" + params);
  } catch (error) {
    return error;
  }
};

//delete waybill in bags
export const deleteWaybillByBagId = async (bagId, orderId) => {
  try {
    return await AoneService.delete(
      `sorting-panel-v2/v1/api/bags/${bagId}/order/${orderId}`
    );
  } catch (error) {
    return error;
  }
};

//printBag
export const printBag = async (params) => {
  try {
    return await AoneService.get(`sorting-panel-v2/v1/api/bags/${params}/label`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
